module.exports = __webpack_public_path__ + "static/media/collection.17e0ec43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection.jpg
// module id = 1120
// module chunks = 33